import { useEffect } from "react";

type KeyboardShortcut =
  | "brush"
  | "clear"
  | "close"
  | "copy"
  | "delete"
  | "download"
  | "fill"
  | "flood"
  | "invert"
  | "line"
  | "new"
  | "redo"
  | "reflectX"
  | "reflectY"
  | "rotateNeg"
  | "rotatePos"
  | "settings"
  | "shortcuts"
  | "translateDown"
  | "translateLeft"
  | "translateRight"
  | "translateUp"
  | "undo";

const cmd: Record<string, KeyboardShortcut> = {
  KeyC: "copy",
  Backspace: "delete",
  KeyS: "download",
  Enter: "new",
  ArrowUp: "reflectX",
  ArrowDown: "reflectX",
  ArrowLeft: "reflectY",
  ArrowRight: "reflectY",
  KeyZ: "undo",
};

const cmdShift: Record<string, KeyboardShortcut> = {
  KeyZ: "redo",
};

const noModifier: Record<string, KeyboardShortcut> = {
  Digit1: "brush",
  Backspace: "clear",
  Escape: "close",
  KeyF: "fill",
  Digit2: "flood",
  KeyI: "invert",
  Digit3: "line",
  BracketLeft: "rotateNeg",
  BracketRight: "rotatePos",
  Slash: "settings",
  Digit0: "shortcuts",
  ArrowDown: "translateDown",
  ArrowLeft: "translateLeft",
  ArrowRight: "translateRight",
  ArrowUp: "translateUp",
};

export function useKeyboardShortcuts(callbacks: {
  [Shortcut in KeyboardShortcut]?: () => void;
}): void {
  useEffect(() => {
    function onKeydown(e: KeyboardEvent): void {
      const shortcut =
        e.metaKey || e.ctrlKey
          ? e.shiftKey
            ? cmdShift[e.code]
            : cmd[e.code]
          : noModifier[e.code];
      if (!shortcut) return;
      const callback = callbacks[shortcut];
      if (callback) {
        e.preventDefault();
        callback();
      }
    }
    window.addEventListener("keydown", onKeydown);
    return () => window.removeEventListener("keydown", onKeydown);
  });
}
